<template>
  <div>
    <cadastro-base
      :salvar="salvar"
      :cancelar-cadastro="cancelar"
    >
      <template slot="conteudo">
        <divisoria-descricao
          :titulo="'Chaves de API'"
          :descricao="'Configure aqui as chaves de acesso para as APIs'"
        />
        <configuracao-api-row
          v-for="(api, $index) in apis"
          :key="$index"
          :value="api"
          :dados="apis"
          :item-acesso="$index"
          @novo="adicionarApi()"
          @remove="removerApi($event)"
        />
      </template>
    </cadastro-base>
  </div>
</template>

<script>
import { generateCode } from '@/@core/utils/utils'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from './shared/services/api'

export default {
  name: 'ConfiguracaoApi',
  components: {
    CadastroBase,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    ConfiguracaoApiRow: () => import('./shared/components/ConfiguracaoApiRow.vue'),
  },
  data() {
    return {
      apis: [],
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.getConfiguracaoApi()
        .then(payload => {
          this.apis = payload.data
          if (!this.apis || this.apis.length === 0) {
            this.adicionarApi()
          }
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        api.addUpdateConfiguracaoApi(this.apis.filter(fil => fil.tipoApi && fil.tipoApi !== ''))
          .then(() => {
            resolve('Salvo com sucesso')
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    cancelar() {
    },
    removerApi(value) {
      let index = 0
      if (!value.code) {
        index = this.apis.findIndex(fin => fin.id === value.id)
      } else {
        index = this.apis.findIndex(fin => fin.code === value.code)
      }
      this.apis.splice(index, 1)

      if (this.apis.length === 0) {
        this.adicionarApi()
      }
    },
    adicionarApi() {
      this.apis.push({
        code: generateCode(),
        tipoApi: null,
        chave: null,
        segredo: null,
      })
    },
  },
}
</script>
